import { Address } from '@app-models';

export class Employer {
    id?: number;
    organizationName: string;
    emailAddress?: string;
    phoneNumber?: string;
    addresses?: Address[];
}
